import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import loadable from '@loadable/component';

import 'assets/css/pages/_filters.scss';
import 'assets/css/pages/_filter-modal.scss';
import { selectLocalizationData } from '../features/localization/localizationSlice';
import { STATUS } from '../../shared/enums';
import FallbackPlaceholder from '../components/common/FallbackPlaceholder';
import { selectRegionalPricesStatus, fetchRegionalPrices } from '../features/regionalPrices/regionalPricesSlice';

const HeroFilter = loadable(() => import('../components/filters/HeroFilter'));
const FilterMain = loadable(() => import('../components/filters/FilterMain'));
const FilterStats = loadable(() => import('../components/filters/FilterStats'));
const PerformanceStats = loadable(() => import('../components/filters/PerformanceStats'));
const ReplacementBlock = loadable(() => import('../components/filters/ReplacementBlock'));
const SockBlock = loadable(() => import('../components/filters/SockBlock'));
const FaqBlock = loadable(() => import('../components/filters/FaqBlock'));

/**
 * @param {Object} props
 * @return {JSX.Element}
 * @constructor
 */

const Filters = props => {
  const {
    staticContext, route, topBarRef, headerRef,
  } = props;
  const dispatch = useDispatch();
  const localization = useSelector(selectLocalizationData);
  const status = useSelector(selectRegionalPricesStatus);
  const { PREFETCHED, SUCCEEDED } = STATUS;

  staticContext.bodyClass = 'filter-page-refactored';

  useEffect(() => {
    if (status === STATUS.IDLE) {
      dispatch(fetchRegionalPrices(localization));
    }
    return undefined;
  }, [ localization ]);

  return (
    <>
      <Helmet>
        <title>{route?.meta?.title}</title>
        <meta name="title" content={route?.meta?.title} />
        <meta name="description" content={route?.meta?.description} />
      </Helmet>
      <HeroFilter fallback={<FallbackPlaceholder />} />
      {[ PREFETCHED, SUCCEEDED ].includes(status)
        && (<FilterMain topBarRef={topBarRef} headerRef={headerRef} />)}
      <FilterStats />
      <PerformanceStats />
      <ReplacementBlock />
      <SockBlock />
      <FaqBlock />
    </>
  );
};


Filters.defaultProps = {
  staticContext: {},
};

export default Filters;
